const initialState = {};

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'S2_CLIENTS_SUCCESS') {
        return { ...state, [action.actionParams.environment]: action.payload };
    }

    if (action.type === 'S2_CLIENTS_FAILURE') {
        return { ...state, [action.actionParams.environment]: null };
    }

    return state;
}

export default reducer;
